import {useEffect, useMemo, useRef} from 'react'
import {useQueryClient} from '@tanstack/react-query'
import {useIngestas} from '@/hooks/bateria/use-bateria'
import {resumirLotes, type LotesResumen} from '@/lib/bateria'

/** Bloquea la cola mientras el lote se lee, porque la cola congelada nacería obsoleta, y la invalida
 * al terminar; un lote detenido (10 min sin avance) no bloquea. */
export function useLoteLeyendo(businessId: string, evaluacionId: string): {lotes: LotesResumen; loteLeyendo: boolean} {
  const queryClient = useQueryClient()
  const {data: ingestas} = useIngestas(businessId, evaluacionId, true)
  const lotes = useMemo(() => resumirLotes(ingestas?.items ?? [], Date.now()), [ingestas])
  const loteLeyendo = lotes.corriendo && !lotes.detenido

  const leyendoAntes = useRef(loteLeyendo)
  useEffect(() => {
    if (leyendoAntes.current && !loteLeyendo) {
      queryClient.invalidateQueries({queryKey: ['bateria-cola', businessId, evaluacionId]})
    }
    leyendoAntes.current = loteLeyendo
  }, [loteLeyendo, queryClient, businessId, evaluacionId])

  return {lotes, loteLeyendo}
}
